<template>
    <div class="flex justify-center w-full">
        <template v-if="selectable">
            <div :class="boxClasses"
                :style="recommended ? 'flex-basis: 5%' : ''"
                @click="$emit('input', data.number)"
            >
                <div v-if="recommended"
                    class="bg-navy text-white absolute text-md font-semibold uppercase"
                    style="inset: 0 0 auto auto; transform-origin: 0 0; transform: translate(29.3%) rotate(45deg); box-shadow: 0 0 0 999px #0d2e52; clip-path: inset(0 -100%);"
                >
                    Recommended
                </div>

                <div :class="titleClasses">
                    {{ title }}
                </div>
                <div class="flex flex-col items-center border-t border-gray-400">
                    <div 
                        class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-4"
                        :class="recommended ? 'p-6' : 'p-4'"
                    >
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">
                            {{ money(data.price) }}
                        </div>
                        <div  
                            v-if="priceWithoutDiscount !== data.price"
                            class="text-navy rounded line-through font-bold whitespace-nowrap"
                        >
                            {{ money(priceWithoutDiscount) }}/mo
                        </div>
                    </div>
                    <div class="w-full pt-4 pb-6 px-6">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
                        </ul>
                    </div>
                    <div class="flex justify-center bg-gray-50 w-full rounded-md">
                        <button class=" flex items-center gap-x-2 text-white my-6 py-2 px-4 rounded-md text-xl"
                                :class="{
                                    'bg-navy-500 text-white': value == data.number,
                                    'bg-orange hover:bg-orange-light': value != data.number
                                }"
                        >
                            <template v-if="value == data.number">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>Selected</span>
                            </template>
                            <template v-else>
                                Select plan
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="w-full md:w-2/5 bg-white shadow tr-box">
                <div class="flex flex-col items-center">
                    <div class="flex flex-col md:flex-row justify-center gap-y-2 md:gap-x-4 items-center p-6">
                        <div class="bg-navy text-white rounded-md py-1.5 px-3 text-28 lg:text-32 font-bold whitespace-nowrap">
                            {{ money(data.price) }}
                        </div>
                        <div class="text-navy rounded line-through font-bold whitespace-nowrap">
                            {{ money(priceWithoutDiscount) }}/mo
                        </div>
                    </div>
                    <div class="w-full py-4 px-6 pb-8" v-if="bullets.length > 0">
                        <ul class="tr-bullets ml-4 flex flex-col gap-y-2">
                            <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        value: {
			type: Number,
			required: true
		},
        data: {
			type: Object,
			required: true
		},
        selectable: {
			type: Boolean,
			default: true
		},
        recommended: {
			type: Boolean,
			default: false
		},
    },
    computed: {
        boxClasses() {
			let classes = [];
			if(this.recommended) {
				classes.push("relative overflow-hidden flex-1 w-full lg:w-auto bg-white shadow rounded-md cursor-pointer");
			} else {
				classes.push("flex-1 w-5/6 lg:w-auto mx-16 lg:mx-0 bg-white shadow rounded-md cursor-pointer");
			}

			if(this.value == this.data.number) {
				classes.push("border border-navy-400 ring-4 ring-navy-400");
			} else {
				classes.push("border border-gray-300 bg-gray-50 hover:ring-4 hover:ring-navy-300 hover:border-navy-300 hover:bg-white");
			}

			return classes.join(" ");
        },
        titleClasses() {
			if(this.recommended) {
				return "text-navy text-28 lg:text-36 font-bold p-6 text-center";
			}

			return "text-navy text-28 lg:text-32 font-bold p-4 text-center";
        },
        title() {
			return "Option " + this.data.number;
        },
        priceWithoutDiscount() {
            let discount = 0;
            
            if(this.data.discounts_250_ja) {
                discount = 250;
            } else if(this.data.discounts_500_ja) {
                discount = 500;
            } else if(this.data.discounts_1000_ja) {
                discount = 1000;
            }

            return this.data.price + discount;
        },
        bullets() {
            let bullets = this.data.description;

			bullets = bullets.replace(/<p>/ig, "");
			bullets = bullets.split("</p>");
			bullets = bullets.map(bullet => bullet.trim());
			bullets = bullets.filter((bullet) => {
                let strippedString = bullet.replace(/(<([^>]+)>)/gi, "");
                strippedString = strippedString.trim();

                return strippedString.length > 0;
            });

			return bullets;
		},
    },
}
</script>